<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="visible"
      :header="form?.id ? 'Editar Fornecedor' : 'Adicionar Fornecedor'"
      modal
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
    >
      <form @submit.prevent="submit" ref="form">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label>Nome</label>
            <InputText
              v-model="form.name"
              name="name"
              v-validate="'required|max:55'"
              :class="{ 'p-invalid': errors.has('name') }"
              autocomplete="off"
            />
            <span v-if="errors.has('name')" class="p-error">
              Nome é Obrigatório (máx. 55 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label>Nome 2</label>
            <InputText
              v-model="form.name2"
              name="name2"
              v-validate="'max:55'"
              :class="{ 'p-invalid': errors.has('name2') }"
              autocomplete="off"
            />
            <span v-if="errors.has('name2')" class="p-error">
              Nome 2 inválido ou muito longo (máx. 55 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>NIF / Nº Contribuinte</label>
            <InputText
              v-model="form.fiscalNumber"
              name="fiscalNumber"
              v-validate="'max:20'"
              :class="{ 'p-invalid': errors.has('fiscalNumber') }"
              autocomplete="off"
            />
            <span v-if="errors.has('fiscalNumber')" class="p-error">
              Contribuinte inválido ou muito longo (máx. 20 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>Telefone</label>
            <InputText
              v-model="form.telephone"
              name="telephone"
              v-validate="'max:60'"
              :class="{ 'p-invalid': errors.has('telephone') }"
              autocomplete="off"
            />
            <span v-if="errors.has('telephone')" class="p-error">
              Telefone muito longo (máx. 60 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>Telemóvel</label>
            <InputText
              v-model="form.mobilPhone"
              name="mobilPhone"
              v-validate="'max:45'"
              :class="{ 'p-invalid': errors.has('mobilPhone') }"
              autocomplete="off"
            />
            <span v-if="errors.has('mobilPhone')" class="p-error">
              Telemóvel muito longo (máx. 45 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label>Email</label>
            <InputText
              v-model="form.email"
              name="email"
              v-validate="'email|max:100'"
              :class="{ 'p-invalid': errors.has('email') }"
              autocomplete="off"
            />
            <span v-if="errors.has('email')" class="p-error">
              Email inválido ou muito longo (máx. 100 caracteres)
            </span>
          </div>



          <div class="p-field p-col-12 p-md-6">
            <label>Morada</label>
            <InputText
              v-model="form.address"
              name="address"
              v-validate="'max:55'"
              :class="{ 'p-invalid': errors.has('address') }"
              autocomplete="off"
            />
            <span v-if="errors.has('address')" class="p-error">
              Morada muito longa (máx. 55 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>Localidade</label>
            <InputText
              v-model="form.city"
              name="city"
              v-validate="'max:43'"
              :class="{ 'p-invalid': errors.has('city') }"
              autocomplete="off"
            />
            <span v-if="errors.has('city')" class="p-error">
              Localidade muito longa (máx. 43 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label>Código Postal</label>
            <InputText
              v-model="form.zipCode"
              name="zipCode"
              v-validate="'max:45'"
              :class="{ 'p-invalid': errors.has('zipCode') }"
              autocomplete="off"
            />
            <span v-if="errors.has('zipCode')" class="p-error">
              Código Postal muito longo (máx. 45 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>NIB / IBAN</label>
            <InputText
              v-model="form.nib"
              name="nib"
              v-validate="'max:28'"
              :class="{ 'p-invalid': errors.has('nib') }"
              autocomplete="off"
            />
            <span v-if="errors.has('nib')" class="p-error">
              NIB muito longo (máx. 28 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>Tipo</label>
            <InputText
              v-model="form.type"
              name="type"
              v-validate="'max:20'"
              :class="{ 'p-invalid': errors.has('type') }"
              autocomplete="off"
            />
            <span v-if="errors.has('type')" class="p-error">
              Tipo muito longo (máx. 20 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label>URL Website</label>
            <InputText
              v-model="form.url"
              name="url"
              v-validate="'max:100'"
              :class="{ 'p-invalid': errors.has('url') }"
              autocomplete="off"
            />
            <span v-if="errors.has('url')" class="p-error">
              URL muito longa (máx. 100 caracteres)
            </span>
          </div>

          <div class="p-field p-col-12">
            <label>Observações</label>
            <Textarea
              v-model="form.obs"
              name="obs"
              v-validate="'max:240'"
              :class="{ 'p-invalid': errors.has('obs') }"
              rows="3"
              autoResize
            />
            <span v-if="errors.has('obs')" class="p-error">
              Observações muito longas (máx. 240 caracteres)
            </span>
          </div>
        </div>
      </form>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import SupplierService from "@/services/supplier.service";

export default {
  name: "SupplierModal",
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: {},
    };
  },
  watch: {
    visible() {
      this.reset();
      if (this.visible === true) {
        this.$validator.reset();
        this.$validator.resume();
        this.form = { ...this.data };
      }
    },
  },
  methods: {
    reset() {
      this.form = {
        id: null,
        name: "",
        name2: "",
        fiscalNumber: "",
        telephone: "",
        mobilPhone: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        nib: "",
        type: "",
        url: "",
        obs: "",
      };
      this.$validator.pause();
      this.$validator.reset();
    },
    cancel() {
      this.$validator.pause();
      this.$validator.reset();
      this.reset();
      return this.$emit("cancel");
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      if (this.form.id) {
        await SupplierService.update(this.form.id, this.form).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Atualizar Fornecedor`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Fornecedor Atualizado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("updated", response);
        });
      } else {
        await SupplierService.create(this.form).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Criar Fornecedor`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Fornecedor Criado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("created", response);
        });
      }

      this.$emit("saved");
    },
  },
};
</script>
